export function getSqeProjectLeadOptions(response) {
  const body = response?.data?.data ?? response?.data;
  const members = Array.isArray(body) ? body : body?.members;
  if (!Array.isArray(members)) return [];

  return members
    .map((member) => {
      const value = Number(member.userId ?? member.id ?? member.employeeId);
      const label = member.fullName || member.employeeFullName || member.employeeName || member.empName || member.name ||
        [member.firstName, member.middleName, member.lastName].filter(Boolean).join(" ");
      return { value, label: String(label || "").trim() };
    })
    .filter((member) => Number.isInteger(member.value) && member.value > 0 && member.label);
}
